import { render, staticRenderFns } from "./LivePlayer.vue?vue&type=template&id=bb3ae768&scoped=true&"
import script from "./LivePlayer.vue?vue&type=script&lang=js&"
export * from "./LivePlayer.vue?vue&type=script&lang=js&"
import style0 from "./LivePlayer.vue?vue&type=style&index=0&id=bb3ae768&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb3ae768",
  null
  
)

export default component.exports